export var BarriRoutes = {
    "/harri-iq/:route": {
        "name": "appLayout.harriSH.harri-iq",
        "type": "frontend",
        "component": "barriTsEmbedingComponent",
        "showGlobalSearch": true,
        "loginRequired": true,
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/barri/barri.module.js");
                }
            },
        ],
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | HarriIQ"
            }
        ],
        route_styles: {
            framework: "bootstrap_v4",
            styles: ["barri"]
        }
    },
    "/harri-iq/liveboards/pinboard/:pinboardId": {
        name: "appLayout.harriSH.harri-iq-pinboard",
        "type": "frontend",
        "component": "barriTsEmbedingComponent",
        "showGlobalSearch": true,
        "loginRequired": true,
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/barri/barri.module.js");
                }
            },
        ],
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | HarriIQ"
            }
        ],
        route_styles: {
            framework: "bootstrap_v4",
            styles: ["barri"]
        }
    },

};